import styled from 'styled-components';

export const Onboarding3Wrapper = styled.div`
`;
